import React, { useState } from "react";
import { Layout, Menu, Dropdown, Button, Spin } from "antd";
import {
  Outlet,
  Link,
  NavLink,
  useLocation,
  useNavigate,
} from "react-router-dom";
import "./MainLayout.css"; // Import the CSS file
import AdminHeader from "./components/AdminHeader/AdminHeader";
import { MenuOutlined } from "@ant-design/icons";
import logo from "../Assets/svg/TPMlogo.svg";
import icon1 from "../Assets/svg/iconMenu1.svg";
import icon2 from "../Assets/svg/iconMenu2.svg";
import icon3 from "../Assets/svg/iconMenu3.svg";
import icon4 from "../Assets/svg/iconMenu4.svg";
import icon5 from "../Assets/svg/iconMenu5.svg";
import icon6 from "../Assets/svg/iconMenu6.svg";
import icon7 from "../Assets/svg/iconMenu7.svg";
import backToWorkspace from "../Assets/svg/backToWorkspace.svg";
import menu3 from "../Assets/svg/menu3.svg";

const { Header, Content, Sider } = Layout;

const ProjectLayout = () => {
  const [loading, setLoading] = useState(false);
  const location = useLocation();

  const [isSmallScreen, setIsSmallScreen] = useState(false);
  const navigate = useNavigate();

  const handleResize = () => {
    if (window.innerWidth < 768) {
      setIsSmallScreen(true);
    } else {
      setIsSmallScreen(false);
    }
  };

  // Event listener for window resize
  window.addEventListener("resize", handleResize);

  if (window.innerWidth < 768 && !isSmallScreen) {
    setIsSmallScreen(true);
  }

  const handleLogout = async (event) => {
    if (event && event.preventDefault) {
      event.preventDefault();
    }

    setLoading(true);
    try {
      // Assuming a simulated delay for logging out
      setTimeout(() => {
        localStorage.removeItem("token");
        setLoading(false);
        navigate("/login");
      }, 1000);
    } catch (error) {
      console.error("Logout failed:", error);
      setLoading(false);
    }
  };

  const menu = (
    <Menu theme="dark" mode="vertical">
      <Menu.Item key="1">
        <Link
          to="/project/dashboard"
          style={{ textDecoration: "none", color: "#6A113C" }}
        >
          Round Dashboard
        </Link>
      </Menu.Item>
      <Menu.Item key="2">
        <Link
          to="/project/planning"
          style={{ textDecoration: "none", color: "#6A113C" }}
        >
          Planning
        </Link>
      </Menu.Item>
      <Menu.Item key="3">
        <Link
          to="/project/implementation"
          style={{ textDecoration: "none", color: "#6A113C" }}
        >
          Implementation
        </Link>
      </Menu.Item>
      <Menu.Item key="4">
        <Link
          to="/project/reporting"
          style={{ textDecoration: "none", color: "#6A113C" }}
        >
          Reporting
        </Link>
      </Menu.Item>
      <Menu.Item key="5">
        <Link
          to="/project/completed"
          style={{ textDecoration: "none", color: "#6A113C" }}
        >
          Completed
        </Link>
      </Menu.Item>
      <Menu.Item key="6">
        <Link
          to="/project/flags"
          style={{ textDecoration: "none", color: "#6A113C" }}
        >
          Flags
        </Link>
      </Menu.Item>
      <Menu.Item key="7">
        <Link
          to="/project/ip-management"
          style={{ textDecoration: "none", color: "#6A113C" }}
        >
          Flags
        </Link>
      </Menu.Item>
      <Menu.Item key="8">
        {location.pathname === "/projects" ? (
          <Link
            to="/dashboard/contracts"
            style={{ textDecoration: "none", color: "#6A113C" }}
          >
            Back to contracts
          </Link>
        ) : (
          <Link
            to="/projects"
            style={{ textDecoration: "none", color: "#6A113C" }}
          >
            Back to Projects
          </Link>
        )}
      </Menu.Item>
      {/* Add more menu items as needed */}
    </Menu>
  );

  return (
    <Layout style={{ minHeight: "100vh" }}>
      {isSmallScreen ? null : (
        <Sider className="sider">
          <div className="menuDesign">
            <img src={logo} style={{ marginBottom: "46px" }} alt="logo" />
          </div>

          <Menu
            theme="dark"
            mode="inline"
            selectedKeys={[location.pathname]}
            className="menu"
          >
            {" "}
            <Menu.Item key="7" style={{ marginBottom: "20px" }}>
              {location.pathname === "/projects" ? (
                <Link
                  to="/dashboard/contracts"
                  style={{ textDecoration: "none", color: "white" }}
                >
                  <img
                    src={backToWorkspace}
                    style={{ marginRight: "12px" }}
                    alt="menu2"
                  />
                  Back to contracts
                </Link>
              ) : (
                <Link
                  to="/projects"
                  style={{ textDecoration: "none", color: "white" }}
                >
                  <img
                    src={backToWorkspace}
                    style={{ marginRight: "12px" }}
                    alt="menu2"
                  />
                  Back to Projects
                </Link>
              )}
            </Menu.Item>
            <p className="siderText">Project Management</p>
            <Menu.Item
              key="1"
              className={
                location.pathname === "/project/dashboard"
                  ? "costum-menu-item-active"
                  : ""
              }
            >
              <Link
                to="/project/dashboard"
                style={{ textDecoration: "none", color: "white" }}
              >
                <img src={icon1} style={{ marginRight: "12px" }} alt="menu1" />
                Round Dashboard
              </Link>
            </Menu.Item>
            <Menu.Item
              key="7"
              className={
                location.pathname === "/project/ip-management"
                  ? "costum-menu-item-active"
                  : ""
              }
            >
              <Link
                to="/project/ip-management"
                style={{ textDecoration: "none", color: "white" }}
              >
                <img src={menu3} style={{ marginRight: "12px" }} alt="menu1" />
                IP Management
              </Link>
            </Menu.Item>
            <Menu.Item
              key="2"
              className={
                location.pathname === "/project/planning"
                  ? "costum-menu-item-active"
                  : ""
              }
            >
              <Link
                to="/project/planning"
                style={{ textDecoration: "none", color: "white" }}
              >
                <img src={icon2} style={{ marginRight: "12px" }} alt="menu2" />
                Planning
              </Link>
            </Menu.Item>
            <Menu.Item
              key="3"
              className={
                location.pathname === "/project/implementation"
                  ? "costum-menu-item-active"
                  : ""
              }
            >
              <Link
                to="/project/implementation"
                style={{ textDecoration: "none", color: "white" }}
              >
                <img src={icon3} style={{ marginRight: "12px" }} alt="menu2" />
                Implementation
              </Link>
            </Menu.Item>
            <Menu.Item
              key="4"
              className={
                location.pathname === "/project/reporting"
                  ? "costum-menu-item-active"
                  : ""
              }
            >
              <Link
                to="/project/reporting"
                style={{ textDecoration: "none", color: "white" }}
              >
                <img src={icon4} style={{ marginRight: "12px" }} alt="menu2" />
                Reporting
              </Link>
            </Menu.Item>
            <Menu.Item
              key="5"
              className={
                location.pathname === "/project/completed"
                  ? "costum-menu-item-active"
                  : ""
              }
            >
              <Link
                to="/project/completed"
                style={{ textDecoration: "none", color: "white" }}
              >
                <img src={icon5} style={{ marginRight: "12px" }} alt="menu2" />
                Completed
              </Link>
            </Menu.Item>
            <Menu.Item
              key="6"
              className={
                location.pathname === "/project/flags"
                  ? "costum-menu-item-active"
                  : ""
              }
            >
              <Link
                to="/project/flags"
                style={{ textDecoration: "none", color: "white" }}
              >
                <img src={icon6} style={{ marginRight: "12px" }} alt="menu2" />
                Flags
              </Link>
            </Menu.Item>
            <Menu.Item
              key="9"
              className={
                location.pathname === "/login"
                  ? "costum-menu-item-active logoutMenu"
                  : "logoutMenu"
              }
              onClick={handleLogout}
            >
              {loading ? (
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    color: "white",
                  }}
                >
                  <Spin size="small" style={{ marginRight: 8 }} />
                  Logging out...
                </div>
              ) : (
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    color: "white",
                  }}
                >
                  <img
                    src={icon7}
                    style={{ marginRight: 12 }}
                    alt="Logout Icon"
                  />
                  Logout
                </div>
              )}
            </Menu.Item>
            {/* Add more menu items as needed */}
          </Menu>
        </Sider>
      )}
      <Layout className="site-layout">
        <Header
          className="adminHeader"
          style={{ minHeight: "100px", padding: "0px !important" }}
        >
          <div className="leftContent">
            {isSmallScreen ? (
              <Dropdown overlay={menu} trigger={["click"]}>
                <MenuOutlined
                  style={{
                    fontSize: "24px",
                    marginBottom: "16px",
                    color: "#6A113C",
                  }}
                />
              </Dropdown>
            ) : null}
          </div>
          <div className="rightContent">
            <AdminHeader />
          </div>
        </Header>
        <Content style={{ margin: "0px", backgroundColor: "white" }}>
          <Outlet style={{ width: "100% !important" }} />
        </Content>
      </Layout>
    </Layout>
  );
};

export default ProjectLayout;
